import React from 'react'
import Select from 'react-select'
import PropTypes from 'prop-types'

export const MultiSelectControl = ({
  disabled,
  value,
  items,
  onChange,
  onBlur,
  ...rest
}) => (
  <wb-select-control>
    <Select
      className="autocomplete"
      classNamePrefix="as"
      disabled={disabled}
      options={items}
      value={value}
      isMulti
      loseMenuOnSelect={false}
      onChange={onChange}
      onBlur={onBlur}
      {...rest}
    />
  </wb-select-control>
)

MultiSelectControl.propTypes = {
  disabled: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  items: PropTypes.array,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
}
